export default __webpack_public_path__ + "static/OpenInfrastructureFoundation-logo-RGB-horiz2-w-78b80123d27e084e1ee64e31340c7698.svg";